<template>
    <div>
        video
    </div>
</template>

<script>
    export default {
        name: "video"
    }
</script>

<style scoped>

</style>
